'use es6';

export const HUBL_CSS = 'HUBL_CSS';
export const HUBL_HTML = 'HUBL_HTML';
export const HUBL_JS = 'HUBL_JS';
export const CSS = 'CSS';
export const HTML = 'HTML';
export const JS = 'JS';
export const JSON = 'JSON';
export const TXT = 'TXT';
export const MD = 'MD';
export const MAP = 'MAP';